import { Badge, Tooltip } from '@zoom/components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AdherenceSettingAcdStatus, AdherenceEventType, AdherenceReasonCode } from '../../graphql/components';
import { recordBy } from '../../utils/array';
import { ACDStatusLabel, getDuplicatedReasonCodes, composeReasonCodeUniqueKey } from './ACDStatusLabel';

type AdherenceSettingACDStatusesProps = {
  duplicatedReasonCodes: ReturnType<typeof getDuplicatedReasonCodes>;
  statuses: AdherenceSettingAcdStatus[];
  eventTypes: AdherenceEventType[];
  reasonCodes: AdherenceReasonCode[];
};

export const AdherenceSettingACDStatuses: React.FC<AdherenceSettingACDStatusesProps> = ({
  duplicatedReasonCodes,
  statuses,
  eventTypes,
  reasonCodes,
}) => {
  const { t } = useTranslation();

  const eventTypesRecord = recordBy(eventTypes, 'id');
  const reasonCodesRecord = recordBy(reasonCodes, 'id');

  const [firstStatus, ...rest] = statuses;

  const firstStatusReasonCode = firstStatus.agentEventReasonCodeId
    ? reasonCodesRecord[firstStatus.agentEventReasonCodeId]
    : undefined;

  return (
    <div className="d-flex">
      <ACDStatusLabel
        eventType={eventTypesRecord[firstStatus.agentEventTypeId]}
        reasonCode={firstStatusReasonCode}
        showSource={
          firstStatusReasonCode ? duplicatedReasonCodes[composeReasonCodeUniqueKey(firstStatusReasonCode)] : false
        }
      />
      {rest.length > 0 && (
        <div className="d-flex align-items-center pl-1 ml-auto">
          <Tooltip
            message={
              <div className="px-2 py-4">
                <strong>{t('scheduleAdherence.acdStatuses')}</strong>
                {statuses.map((status) => {
                  const reasonCode = status.agentEventReasonCodeId
                    ? reasonCodesRecord[status.agentEventReasonCodeId]
                    : undefined;

                  return (
                    <ACDStatusLabel
                      key={`${status.agentEventTypeId}-${status.agentEventReasonCodeId}`}
                      className="acd-status-label--list"
                      eventType={eventTypesRecord[status.agentEventTypeId]}
                      reasonCode={reasonCode}
                      showSource={reasonCode ? duplicatedReasonCodes[composeReasonCodeUniqueKey(reasonCode)] : false}
                    />
                  );
                })}
              </div>
            }
          >
            <Badge className="adherence-settings__badge">+{rest.length}</Badge>
          </Tooltip>
        </div>
      )}
    </div>
  );
};
